module.exports = __webpack_public_path__ + "img/img_works07.4a4d8a52.jpg";